<template>
  <v-card>
    <v-progress-linear indeterminate :active="fetching" color="primary"></v-progress-linear>
    <v-toolbar flat v-if="preference">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar>
          <v-icon dark color="info">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Author</v-list-item-title>
          <v-list-item-subtitle>{{ full_name }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn small color="primary" text rounded>
            <v-icon left>mdi-open-in-new</v-icon>Show
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-divider vertical></v-divider>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Created At</v-list-item-title>
          <v-list-item-subtitle>{{preference.created_at}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider vertical></v-divider>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Status</v-list-item-title>
          <v-list-item-subtitle
            :class="`${preference.status == 'published' ?  'primary': 'warning'}--text`"
          >{{preference.status}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            v-if="preference.status != 'published'"
            rounded
            outlined
            text
            color="primary"
            @click="() => publish(preference.uuid)"
          >
            Publish
            <v-icon right>mdi-playlist-check</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            outlined
            v-else
            rounded
            text
            @click="() => unpublish(preference.uuid)"
          >
            Unpublish
            <v-icon right>mdi-playlist-minus</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-toolbar>
    <v-divider></v-divider>
    <v-container v-if="preference">
      <v-row>
        <v-col cols="12" md="8">
          <v-list-item three-line class="px-0">
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                <h1>{{ preference.title }}</h1>
              </v-list-item-title>
              <v-list-item-subtitle>{{ trans('advert.property_type_' + preference.property_type) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-row no-gutters class="mb-3">
            <v-col cols="4">
              <v-list-item two-line class="px-0">
                <v-list-item-avatar>
                  <v-icon dark color="primary">mdi-home</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Amount of rooms</v-list-item-title>
                  <v-list-item-subtitle>{{ preference.room_amount }} rooms</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item two-line class="px-0">
                <v-list-item-avatar>
                  <v-icon dark color="primary">mdi-account-supervisor</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Occupants Amount</v-list-item-title>
                  <v-list-item-subtitle>{{ preference.occupants_amount }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="4">
              <v-list-item two-line class="px-0">
                <v-list-item-avatar>
                  <v-icon dark color="primary">mdi-account-multiple-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Room Size</v-list-item-title>
                  <v-list-item-subtitle>{{ preference.room_size || '-'}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <div class="my-3 py-3">
            <h2 class="mb-3">Decription</h2>
            <div>{{ preference.description }}</div>
          </div>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="12">
              <div class="my-3 py-3">
                <h2 class="mb-3">About</h2>
                <about-list :preference="preference"></about-list>
              </div>
            </v-col>
          </v-row>

          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" md="4" class="preference-detail-price">
          <v-list-item two-line>
            <v-list-item-avatar>
              <v-icon color="primary">mdi-calendar</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                <b>Available From</b>
              </v-list-item-title>
              <v-list-item-subtitle>{{ preference.available_from}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item two-line>
            <v-list-item-avatar>
              <v-icon color="primary">mdi-cash-multiple</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                <b>Max price</b>
              </v-list-item-title>
              <v-list-item-subtitle c>{{ preference.price_max }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item two-line>
            <v-list-item-avatar>
              <v-icon color="primary">mdi-currency-usd</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                <b>Currency</b>
              </v-list-item-title>
              <v-list-item-subtitle>{{ preference.price_currency}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import AboutList from "../../components/preferences/AboutList";
export default {
  components: {
    "about-list": AboutList
  },
  computed: {
    ...mapState("preferences", {
      fetching: "fetching",
      preference: "preference"
    }),
    full_name() {
      if (!this.preference.author) return "-";
      return (
        this.preference.author.first_name +
        " " +
        this.preference.author.last_name
      );
    }
  },
  methods: {
    ...mapActions("preferences", {
      fetch: "show",
      publish: "publish",
      unpublish: "unpublish"
    })
  },
  mounted() {
    if (this.$route.params.uuid) {
      this.fetch(this.$route.params.uuid);
    }
  }
};
</script>

<style lang="scss" scoped></style>
